import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue';
import Money from '@/app/shared/domain/classes/money';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputMoney',
  props: ['modelValue', 'label', 'rules'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;



const input = ref(null);

const value = computed({
    get() {
        return props.modelValue ? Money.fromStringBR(String(props.modelValue)).toStringBR() : '';
    },
    set(value) {
        let cents = Money.fromStringBR(value).getCentsAsString();
        emit('update:modelValue', isNaN(cents) ? '' : cents);
        input.value.blur();
        input.value.focus();
    },
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, {
    label: __props.label,
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
    ref_key: "input",
    ref: input,
    rules: __props.rules
  }, null, 8, ["label", "modelValue", "rules"]))
}
}

})